const priceFormatter = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
})

const E_LEARNING_FORMAT = 'e_learning'

export const formatPrice = (value: string): string => {
  const amount = Number(value)
  return value.trim() === '' || Number.isNaN(amount) ? '' : priceFormatter.format(amount)
}

// Inside the checkout, e-learning is billed with 19 % VAT, so the customer sees the gross amount
// the middleware got from DSC. Everywhere else (cart flyout, course detail, search) the net price
// stays authoritative. Falls back to net when no gross value was delivered — course variants carry
// no gross price at all.
export const resolveCheckoutPrice = (net: string, gross: null | string, format: string): string =>
  format === E_LEARNING_FORMAT && gross !== null && gross !== '' ? gross : net

// In the cart flyout the customer always sees the NET price (VAT is only added at checkout, see
// resolveCheckoutPrice). unitPrice carries the amount actually charged — gross for e-learning — so
// the cart must not use it; it shows the net price of the reserved tier (member or normal) instead.
export const resolveCartPrice = (net: string, memberNet: string, isMember: boolean): string =>
  isMember ? memberNet : net

export const applyPriceTooltipVariant = (content: HTMLElement, format: string): void => {
  const mediaText = content.dataset.priceInfoMedia
  if (mediaText === undefined) return

  const generalText = content.dataset.priceInfoGeneral ?? (content.textContent ?? '').trim()
  content.dataset.priceInfoGeneral = generalText
  content.textContent = format === E_LEARNING_FORMAT ? mediaText : generalText
}
